import React from 'react';

import { StatusColor, useStyles } from './styles';

/**
 * @param {Object} props
 * @param {number} props.size
 * @param {string} props.color
 * @param {Function} [props.onClick]
 * @param {Function} [props.onMouseEnter]
 * @param {string} props.status
 * @param {string} props.customClass
 */
const ColorIndicator = ({ color, size, status, customClass, ...rest }) => {
  const classes = useStyles({ size, backgroundColor: color || StatusColor[status] });

  return (
    <button
      aria-label="Show details"
      type="button"
      className={customClass || classes.colorIndicator}
      {...rest}
    />
  );
};

ColorIndicator.defaultProps = {
  size: 50,
  color: undefined,
  status: '',
  customClass: null,
  onClick: undefined,
  onMouseEnter: undefined
};

export default ColorIndicator;
